import { SocialMediaPostTemplateService } from '@/scripts/services/social-media/social-media-post-template-service';
import { SocialMediaAccountTemplateService } from '@/scripts/services/social-media/social-media-account-template-service';

export const SocialMediaPostTemplatesMixin = {

    methods: {
        // Query methods

        getFilterArrayOfFiles(arrayFiles) {
            let finalQueryReq = '';
            let insideIds = '';
            arrayFiles.forEach((element, index) => {
                if (index === 0) {
                    insideIds = `"${element}"`;
                } else {
                    insideIds += `,"${element}"`;
                }
            });
            finalQueryReq = `Ids=[${insideIds}]`;
            return '?' +  finalQueryReq;
        },

        // Services

        // Get post by id
        getPostTemplateDetails(id, accountId) {
            return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.get(id, accountId)
                .then(({ data }) => resolve(data.data))
                .catch(reject);
            });
        },

        // Upload File
        async uploadTemplateFile(service, img, type, name) {
            let dataImg = await fetch(img);
            const buff = await dataImg.arrayBuffer();
            const fileToUpload = new File([buff], name, { type: type });

            const config = {
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': type,
                    'Access-Control-Allow-Origin': '*'
                },
            };
            
            return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.putImage(service, fileToUpload, config)
                .then(() => resolve({
                    message: 'ok',
                }))
                .catch(reject);
            });
        },

        // Create a post template draft
        createPostTemplateDraft(args, accountId) {
            const jsonData = {
                templateName: args.templateName,
                templateText: args.templateText,
                templateCategories: args.templateCategories,
                templateMediaIds: [],
            };

            if (args.templateMediaIds) {
                jsonData.templateMediaIds = args.templateMediaIds;
            }

            if (args.pageShareUrl !== '') {
                jsonData.pageShareUrl = args.pageShareUrl;
            }
            
            return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.post(accountId, args)
                .then(({ data }) => resolve(data.data.id))
                .catch(reject);
            });
        },

        // Update Post Draft
        updatePostTemplateDraft(idPost, accountId, payload) {
            const jsonData = {
                templateName: payload.templateName,
                templateText: payload.templateText,
                templateCategories: payload.templateCategories,
                pageShareUrl: payload.pageShareUrl,
                templateMediaIds: [],
            };

            if (payload.templateMediaIds) {
                jsonData.templateMediaIds = payload.templateMediaIds;
            }


            return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.patch(idPost, accountId, jsonData)
                .then(({ data }) => resolve(data))
                .catch(reject);
            });
        },

        updateWidgetPostTemplateDraft(idPost, accountId, payload) {
            const jsonData = {
                templateName: payload.templateName,
                templateCategories: payload.templateCategories,
                socialNetworkAccountIds: payload.socialNetworkAccountIds
            };

            return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.patch(idPost, accountId, jsonData)
                .then(({ data }) => resolve(data))
                .catch(reject);
            });
        },

        // Delete post
        deletePostTemplateFromAccount(postId, accountId){
            return new Promise((resolve, reject) => {
                SocialMediaAccountTemplateService.delete(postId, accountId)
                .then(({ data }) => resolve(data))
                .catch(reject);
            });
        },

        // Save or create network version
        savePostTemplateNetworkVersion(network, templateId, args, versionId = false, accountId) {
            if(network == 'original') { 
                return 'skipped';
            }

            const jsonData = {
                socialNetworkAccountId: parseInt(network),
                socialPostTemplateId: parseInt(templateId),
                templateText: args.templateText,
                visibility: args.visibility,
                templateCategories: args.templateCategories,
                pageShareUrl: args.pageShareUrl,
                templateMediaIds: [],
            };

            if(args.date) {
                jsonData.date = args.date;
            }

            if (args.templateMediaIds) {
                jsonData.templateMediaIds = args.templateMediaIds;
            }

            return new Promise((resolve, reject) => {
                if (versionId) {
                    SocialMediaAccountTemplateService.patch(versionId, accountId, jsonData)
                    .then(({ data }) => resolve(data))
                    .catch(reject);
                } else {
                    SocialMediaAccountTemplateService.post(accountId, jsonData)
                    .then(({ data }) => resolve(data))
                    .catch(reject);
                }
            });
        },

        duplicateMediaPostTemplate(accountId, payload){
             return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.postBulk(accountId, payload)
                .then(({ data }) => resolve(data.data))
                .catch(reject);
            });
        }
    },
};